import BaseModal from "../../components/BaseModal";
import BaseButton from "../../components/BaseButton";
import React from "react";
import { useTranslation } from "react-i18next";
import { MODAL_TYPES } from "../../utils/emitter";
import "./style.scss";
import { useLocation, useNavigate } from "react-router-dom";
import useModalActions from "../../hooks/useModalActions";
import ROUTES from "../../utils/routes";
import useCookie from "../../hooks/useCookie";

export default function FirstTimeInGameModal() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { closeModal, openModal } = useModalActions();
  const { removeCookie } = useCookie();
  const location = useLocation();
  return (
    <BaseModal
      preventClose
      contentStyle="buttons-container"
      eventTypeModal={MODAL_TYPES.FIRST_TIME_PLAYING}
      onClose={() => {
        removeCookie("isWatchFirstTimeGameModal");
      }}
    >
      <BaseButton
        typeSpinner="light"
        onClick={() => {
          navigate(
            ROUTES.REGISTER_PAGE,
            location.state ? { state: { ...location.state } } : {}
          );
          closeModal(MODAL_TYPES.FIRST_TIME_PLAYING);
          // openModal(MODAL_TYPES.GENDER_NOTIFICATION, {
          //   type: "noauth",
          //   message: t("genderModal.noauthText"),
          // });
          removeCookie("isWatchFirstTimeGameModal");
        }}
      >
        {t("firstTimeInGame.firstTime")}
      </BaseButton>
      <BaseButton
        unfilledWhite
        className="modal-button-cancel"
        onClick={() => {
          navigate(
            ROUTES.LOGIN_PAGE,
            location.state ? { state: { ...location.state } } : {}
          );
          closeModal(MODAL_TYPES.FIRST_TIME_PLAYING);
          removeCookie("isWatchFirstTimeGameModal");
        }}
      >
        {t("firstTimeInGame.alreadyHasAcc")}
      </BaseButton>
    </BaseModal>
  );
}
